export default __webpack_public_path__ + "static/belka_rozdzialy_left-1b330f3baa92300f1c0a07d1d2c2f688.png";